<template>
  <loading-page v-if="gettingInvoice || gettingUpcomingInvoice" />
  <div
    v-else
    class="row text-break"
  >
    <div class="col-12 col-lg-10 col-xl-9 m-auto">
      <div class="mb-2">
        <b-button
          variant="icon-light"
          class="shadow"
          @click="$router.push({ name: 'billing-invoices' })"
        >
          <GjIcon name="ArrowLeft" />
          Back
        </b-button>
      </div>
      <div class="d-flex flex-wrap align-items-center">
        <h3 class="text-main mr-1">
          {{ invoice.number }}
          <span class="text-thin"> for </span>
          {{ currencySymbol }}{{ invoice.total / 100 }}
        </h3>
        <div>
          <span
            class="text-capitalize tag"
            :class="invoice.status"
          >{{
            invoice.status
          }}</span>
        </div>
      </div>
      <div class="mt-2">
        <paper-simple>
          <p class="text-main">
            Summary
          </p>
          <div class="d-flex flex-wrap">
            <input-field
              label="Billed to"
              label-position="top"
              class="px-0 col-sm-6"
            >
              {{ invoice.customerEmail || '-' }}
            </input-field>
            <input-field
              label="Currency"
              label-position="top"
              class="px-0 col-sm-6"
            >
              <span class="text-uppercase mr-05">{{
                invoice.currency || '-'
              }}</span>
              {{
                currencyName !== invoice.currency ? ` - ${currencyName}` : ''
              }}
            </input-field>
            <input-field
              label="Name"
              label-position="top"
              class="px-0 col-sm-6"
            >
              {{ invoice.customerName || '-' }}
            </input-field>
            <input-field
              label="Invoice number"
              label-position="top"
              class="px-0 col-sm-6"
            >
              {{ invoice.number || '-' }}
            </input-field>
            <input-field
              label="Date"
              label-position="top"
              class="px-0 col-sm-6"
            >
              {{ formatOffsetDateTime(invoice.created) || '-' }}
            </input-field>
            <input-field
              v-if="invoice.customerAddress"
              label="Address"
              label-position="top"
              class="px-0 col-sm-6"
            >
              <span v-if="invoice.customerAddress.line1">{{
                invoice.customerAddress.line1
              }}</span>
              <span
                v-if="invoice.customerAddress.city"
              >, {{ invoice.customerAddress.city }}</span>
              <span
                v-if="invoice.customerAddress.state"
              >, {{ invoice.customerAddress.state }}</span>
              <span
                v-if="invoice.customerAddress.postalCode"
              >, {{ invoice.customerAddress.postalCode }}</span>
              <span
                v-if="invoice.customerAddress.country"
              >, {{ invoice.customerAddress.country }}</span>
            </input-field>
          </div>
        </paper-simple>
        <div class="default-table">
          <invoice-table
            :invoice="invoice"
            :currency-symbol="currencySymbol"
            :getting-invoice="gettingInvoice"
          />
        </div>
        <div class="default-table">
          <div class="table-actions">
            <p class="mb-0">
              Payments
            </p>
          </div>
          <b-table
            ref="table"
            :items="invoice.payment"
            :fields="paymentFields"
            class="loaded"
            show-empty
            responsive
          >
            <template #empty>
              <transition
                name="fade"
                mode="out-in"
              >
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                  style="height: 220px"
                >
                  <GjIcon name="PaymentAlt" />
                  <p>No payments yet</p>
                </div>
              </transition>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import currencies from '../currencies'
import InvoiceTable from '../parts/InvoiceTable.vue'

export default {
  name: 'InvoiceDetails',
  components: { InvoiceTable },
  data() {
    return {
      id: '',
      fields: [
        { key: 'nickname', label: 'Type' },
        {
          key: 'description',
          thClass: 'd-none d-lg-table-cell',
          tdClass: 'd-none d-lg-table-cell',
        },
        { key: 'quantity', label: 'Qty', tdClass: 'text-right' },
        { key: 'unitPrice', tdClass: 'text-right' },
        { key: 'total', tdClass: 'text-right', variant: 'price' },
      ],
      currencies,
      paymentFields: ['amount', 'status', 'description', 'date'],
    }
  },
  computed: {
    invoice() {
      return this.isUpcoming
        ? this.$store.state.payments.upcomingInvoice
        : this.$store.state.payments.invoice
    },
    gettingInvoice() {
      return this.$store.state.payments.gettingInvoice
    },
    gettingUpcomingInvoice() {
      return this.$store.state.payments.gettingUpcomingInvoice
    },
    currencyName() {
      const el = this.currencies.find(
        element => element.code === this.invoice.currency,
      )
      return el ? el.name : this.invoice.currency
    },
    currencySymbol() {
      const el = this.currencies.find(
        element => element.code === this.invoice.currency,
      )
      return el ? el.symbol : this.invoice.currency
    },
    isUpcoming() {
      return this.$route.params.isUpcoming
    },
  },
  created() {
    this.id = this.$route.params.id

    if (this.isUpcoming) {
      this.$store.dispatch('payments/getUpcomingInvoice')
    } else {
      this.$store.dispatch('payments/getInvoice', this.id)
    }
  },
}
</script>
<style lang="scss" scoped>
// .back {
//   @media (min-width: 992px) {
//     position: absolute;
//   }
// }
.tag {
  box-sizing: border-box;
  border-radius: 20px;
  padding: 2px 8px;
  color: var(--white);
  font-weight: bold;
  &.paid {
    background: var(--success);
    border: 1px solid var(--success);
  }
  &.draft {
    background: #667c99;
    border: 1px solid #667c99;
  }
  &.open {
    background: var(--primary);
    border: 1px solid var(--primary);
  }
  &.void {
    background: var(--warning);
    border: 1px solid var(--warning);
  }
  &.uncollectible {
    background: var(--danger);
    border: 1px solid var(--danger);
  }
}

.mr-05 {
  margin-right: 5px;
}
</style>
